import { render, staticRenderFns } from "./salidaLotesSeries.vue?vue&type=template&id=f617e1a0&"
import script from "./salidaLotesSeries.vue?vue&type=script&lang=js&"
export * from "./salidaLotesSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QList,QItem,QItemSection,QBtn,QBadge,QScrollArea,QInput,QIcon,QTooltip,QSeparator,QTable,QTd,QForm} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QCardSection,QList,QItem,QItemSection,QBtn,QBadge,QScrollArea,QInput,QIcon,QTooltip,QSeparator,QTable,QTd,QForm})
